import GeneratedMailFolderStore from "./generated/GeneratedMailFolderStore"

class MailFolderStore extends GeneratedMailFolderStore {

}

export const mailFolderStore = new MailFolderStore()
